import React, {
  useState,
} from 'react';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Item = {
  id: number,
  name: string,
};

type Props = {
  readOnly: boolean,
  exercise: Item,
  number: string,
  numbers: string[],
  onChange: { (): void },
};

const ExerciseOrder = ({
  number,
  numbers,
  readOnly,
  exercise,
  onChange,
}: Props) => {
  const [uniqueNumbers, addNumber] = useState(
    Array.from(new Set(numbers)),
  );
  const [isOpen, setIsOpen] = useState(false);
  return readOnly ? (
    <S.OrderName
      number={number}
    >
      {exercise.order_name}
    </S.OrderName>
  ) : (
    <S.StyledPopover
      body={(
        <S.ExerciseOrder>
          <Flex
            align="center"
            spacing={5}
          >
            {uniqueNumbers.map(item => (
              <S.NumberContainer
                key={item}
                number={item}
                onClick={() => {
                  if (number !== item) onChange(exercise.id, item);
                  setIsOpen(false);
                }}
              >
                {item}
              </S.NumberContainer>
            ))}
            {uniqueNumbers.length < 26 && (
              <S.Add
                onClick={() => {
                  addNumber([
                    ...uniqueNumbers,
                    uniqueNumbers[uniqueNumbers.length - 1] + 1,
                  ]);
                }}
              />
            )}
          </Flex>
        </S.ExerciseOrder>
      )}
      isOpen={isOpen}
      preferPlace="right"
      onOuterAction={() => setIsOpen(false)}
    >
      <Tooltip
        preferPlace="above"
        body="Create supersets by assigning the same number/color to exercises."
      >
        <S.OrderName
          number={number}
          onClick={() => setIsOpen(!isOpen)}
        >
          {exercise.order_name}
        </S.OrderName>
      </Tooltip>
    </S.StyledPopover>
  );
};

export default ExerciseOrder;
